import { useMemo } from 'react';

export function useMemoQueryKey<A extends readonly any[]>(...args: A) {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	return useMemo(() => args, args);
}
